import { makeRoute } from '~/utils/route';
import controller from './list.controller';
import template from './list.html';
import './list.scss';

export default makeRoute({
	path:           '/list/:kid',
	template,
	controller,
	reloadOnSearch: false,
});
